export let QUTOffering = { activeTab: "target" }
